import { Box, Link, Stack, Typography } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'

import style from './style'

const LegalNotice = () => {
  const intl = useIntl()

  return (
    <Box sx={style.container}>
      <Box sx={style.titleContainer}>
        <Typography variant="h1" fontSize={48} color="secondary">
          <FormattedMessage id="LegalNotice.Title" defaultMessage="Legal notice" />
        </Typography>
      </Box>

      <div>
        <Typography variant="h2" fontSize={24} fontWeight={500} color="secondary">
          <FormattedMessage id="LegalNotice.Company" defaultMessage="Company identification" />
        </Typography>
        <Box sx={style.sectionContent}>
          QuantumBio Vins <br />
          <Stack direction="row" gap={0.5}>
            <FormattedMessage id="LegalNotice.Address" defaultMessage="Address:" />
            <div>
              23 chemin de la Nonnette <br />
              1292 Chambesy <br />
              Suisse
            </div>
          </Stack>
          <FormattedMessage id="LegalNotice.Email" defaultMessage="Email:" />{' '}
          <Link href="mailto:juliette@quantumbioconsulting.ch">
            juliette@quantumbioconsulting.ch
          </Link>
          <br />
          <FormattedMessage id="LegalNotice.Phone" defaultMessage="Phone:" />{' '}
          <Link href="tel:+41786040193">+41 78 604 01 93</Link> <br />
          <FormattedMessage id="LegalNotice.TVA" defaultMessage="TVA number:" /> CHE-385.435.543
        </Box>

        <Typography variant="h2" fontSize={24} fontWeight={500} color="secondary">
          <FormattedMessage id="LegalNotice.Host.Title" defaultMessage="Host" />
        </Typography>
        <Box sx={style.sectionContent}>
          <FormattedMessage id="LegalNotice.Host" defaultMessage="Host:" /> Infomaniak Network SA
          <br />
          <Stack direction="row" gap={0.5}>
            <FormattedMessage id="LegalNotice.Address" defaultMessage="Address:" />
            <div>
              Rue Eugène-Marziano 25 <br />
              1227 Les Acacias <br />
              Genève <br />
              Suisse
            </div>
          </Stack>
          <FormattedMessage
            id="LegalNotice.Host.Contact"
            defaultMessage="Contact: Contact through their {link}"
            values={{
              link: (
                <Link
                  href={intl.formatMessage({
                    id: 'LegalNotice.Host.Contact.Link',
                    defaultMessage: 'https://www.infomaniak.com/en/help',
                  })}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FormattedMessage
                    id="LegalNotice.Host.Contact.HelpCenter"
                    defaultMessage="help center"
                  />
                </Link>
              ),
            }}
          />
        </Box>

        <Typography variant="h2" fontSize={24} fontWeight={500} color="secondary">
          <FormattedMessage id="LegalNotice.Editor" defaultMessage="Editor" />
        </Typography>
        <Box sx={style.sectionContent}>
          <FormattedMessage id="LegalNotice.WebsiteName" defaultMessage="Website name:" />{' '}
          QuantumBio Vins <br />
          <FormattedMessage
            id="LegalNotice.PublicationManager"
            defaultMessage="Publication manager:"
          />{' '}
          Joris Harnetiaux <br />
          <FormattedMessage id="LegalNotice.Contact" defaultMessage="Contact:" />{' '}
          <Link href="mailto:jorisharnetiaux@gmail.com">jorisharnetiaux@gmail.com</Link>
        </Box>

        <Typography variant="h2" fontSize={24} fontWeight={500} color="secondary">
          <FormattedMessage id="LegalNotice.Copyright" defaultMessage="Copyright" />
        </Typography>
        <Box sx={style.sectionContent}>
          <FormattedMessage
            id="LegalNotice.CopyrightContent"
            defaultMessage="All elements on this website, including texts, images, graphics, logos, and icons, are protected by copyright and intellectual property laws.{br}Any reproduction, distribution, modification, or use without prior authorization is strictly prohibited.{br}{br}© 2025 QuantumBio Vins – All rights reserved."
            values={{ br: <br /> }}
          />
        </Box>

        <Typography variant="h2" fontSize={24} fontWeight={500} color="secondary">
          <FormattedMessage
            id="LegalNotice.DataProtectionAndCookies"
            defaultMessage="Data Protection and Cookie Usage"
          />
        </Typography>
        <Box sx={style.sectionContent}>
          <FormattedMessage
            id="LegalNotice.DataProtectionAndCookies.Intro"
            defaultMessage="We take your privacy very seriously."
          />
        </Box>
        <Typography variant="h3" fontSize={18} fontWeight={500} color="secondary">
          <FormattedMessage id="LegalNotice.PersonalData" defaultMessage="Personal Data" />
        </Typography>
        <Box sx={style.sectionContent}>
          <FormattedMessage
            id="LegalNotice.PersonalDataContent"
            defaultMessage="This website does not collect, store, or process any personal data from visitors."
          />
        </Box>
        <Typography variant="h3" fontSize={18} fontWeight={500} color="secondary">
          <FormattedMessage id="LegalNotice.Cookies" defaultMessage="Cookies" />
        </Typography>
        <Box sx={style.sectionContent}>
          <FormattedMessage
            id="LegalNotice.CookiesContent"
            defaultMessage="This website does not use any cookies or tracking tools to collect browsing information."
          />
        </Box>
        <Box sx={style.sectionContent}>
          <FormattedMessage
            id="LegalNotice.DataProtectionContact"
            defaultMessage="For any questions, you can contact us at {email}."
            values={{
              email: (
                <Link href="mailto:juliette@quantumbioconsulting.ch">
                  juliette@quantumbioconsulting.ch
                </Link>
              ),
            }}
          />
        </Box>
      </div>
    </Box>
  )
}

export default LegalNotice
